(ns app.front.view.admin.commands.user-integrations
  (:require [app.front.ui :as ui]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::email
  :-> ::email)

(rf/reg-event-db ::set-email
  (fn [db [_ email]]
    (-> db
        (dissoc ::user)
        (assoc ::email email))))

(rf/reg-sub ::email-valid?
  :<- [::email]
  (fn [email _]
    (not (str/blank? email))))

(rf/reg-event-fx ::find-user
  (fn [_ [_ email]]
    {:comm/command {:command    :admin/get-user-integrations
                    :method     :get
                    :data       (util/mmap email)
                    :on-success [::find-user.success]}}))

(rf/reg-event-fx ::find-user.success
  (fn [{:keys [db]} [_ status resp]]
    (when (= 200 status)
      {:db (-> db
               (assoc ::user resp))})))

(rf/reg-sub ::user
  (fn [db _]
    (-> db
        ::user
        (update :integrations (partial sort-by :user.integration/customer-id)))))

(rf/reg-sub ::user-fetched?
  (fn [db _]
    (-> db ::user some?)))

(defn set-state [db updated-id new-state]
  (update db ::user update :integrations (partial map (fn [{:keys [:db/id] :as i}]
                                                        (if (= id updated-id)
                                                          (assoc i :state new-state)
                                                          i)))))

(rf/reg-event-fx ::remove-integration
  (fn [{:keys [db]} [_ user-id integration-id user-integration-id customer-id]]
    {:db           (set-state db integration-id :in-progress)
     :comm/command {:command    :admin/remove-user-integration
                    :method     :post
                    :data       (util/mmap user-id integration-id user-integration-id customer-id)
                    :on-success [::remove-integration.success integration-id]}}))

(rf/reg-event-db ::remove-integration.success
  (fn [db [_ updated-id]]
    (set-state db updated-id :removed)))

(defn remove-button [user-id email {user-integration-id :user.integration/user-id
                                    :keys               [:db/id :user.integration/customer-id state]}]
  (case state
    :removed
    [:span "Removed"]
    :in-progress
    (cc/loading-spinner {:small true :with-overlay false})

    ;; else
    [ui/modal-confirmation-button
     {:text-button?        true
      :trigger-button-text "Remove link"
      :tr                  (<sub [:tr])
      :on-yes-click        (fn [_]
                             (>evt [::remove-integration user-id id user-integration-id customer-id]))}
     [:div "Do you really want to remove the link to external system for "
      [:span.bold user-integration-id] " for user " (str email)]]))

(defn integrations-list []
  (let [{:keys [id email name integrations]} (<sub [::user])]
    [:div
     [:h3 name [:span.italic.ml-4 email]]
     [:a.block.mb-4 {:href (href/href :view/admin.entity-lookup-with-param
                                      {:search-term (str id)})}
      "Open entity lookup"]
     (if (seq integrations)
       [ui-table/modern-responsive-table
        {:items integrations
         :link  {:description "To entity-lookup"
                 :make-href   (fn [{user-id :db/id}]
                                (href/href :view/admin.entity-lookup-with-param
                                           {:search-term (str user-id)}))}
         :cols  [["Municipality" :user.integration/customer-id]
                 ["User integration id" :user.integration/user-id]
                 ["" (partial remove-button id email)]]}]
       [:span.bold "No integrations found for this user"])]))

(defn view [match]
  (let [email (<sub [::email])]
    [acommon/admin-page (util/mmap {:title "Manage user integrations"} match)
     [:section
      [:h2 "Disable user integrations"]
      [ui/help "This tool can be used to de-link user(s) from external back-end system integrations, e.g. AMANDA. Removing an integration link removes the link only in Cloudpermit database. The other system may need to be updated correspondingly."]
      [:div.flex.items-end
       [ui/text-input
        {:id         "user-email"
         :label-text "Email address of the user"
         :on-change  #(rf/dispatch-sync [::set-email (futil/tval %)])
         :value      email}]
       [:div.ml-2
        (cc/button
          {:on-click #(>evt [::find-user email])
           :disabled (not (<sub [::email-valid?]))}
          "Find user")]]]
     (when (<sub [::user-fetched?])
       [:section
        [integrations-list]])]))

(def route
  {:name :view/admin.commands.user-integrations
   :view view})
